const balloonData = `
<h2>Walking the capitals of Europe: Warsaw</h2>

\t<figure class="media">
\t\t<oembed url="https://www.youtube.com/watch?v=WmWFwGLA1kQ"></oembed>
\t</figure>

\t<p>If you enjoyed my previous articles in which we discussed wandering around <a href="https://en.wikipedia.org/wiki/Copenhagen">Copenhagen</a> and <a href="https://en.wikipedia.org/wiki/Vilnius">Vilnius</a>, you’ll definitely love exploring <a href="https://en.wikipedia.org/wiki/Warsaw">Warsaw</a>.</p>

\t<h3>Time to put comfy sandals on!</h3>

\t<p>Best time to visit the city is July and August, when it’s cool enough to not break a sweat and hot enough to enjoy summer. The city which has quite a combination of both old and modern textures is located by the river of Vistula.</p>

\t<p>The historic <strong>Old Town</strong>, which was reconstructed after the World War II, with its late 18th century characteristics, is a must-see. You can start your walk from the <strong>Nowy Świat Street</strong> which will take you straight to the Old Town.</p>

\t<p>Then you can go to the <strong>Powiśle</strong> area and take a walk on the newly renovated promenade on the riverfront. There are also lots of cafes, bars and restaurants where you can shake off the exhaustion of the day. On Sundays, there are many parks where you can enjoy nature or listen to pianists from around the world playing Chopin.</p>

\t<p>For museum lovers, you can add these to your list:</p>

\t<ul>
\t\t<li><a href="http://www.polin.pl/en">POLIN</a></li>
\t\t<li><a href="http://www.1944.pl/en">Warsaw Uprising Museum</a></li>
\t\t<li><a href="http://chopin.museum/en">Fryderyk Chopin Museum</a></li>
\t</ul>

\t<h3>Next destination</h3>

\t<p>We will go to Berlin and have a night's walk in the city that never sleeps! Make sure you subscribe to our newsletter!</p>`;
export default balloonData;
